import { normalizeLeadCapturePayload } from './leadCaptureSchema';

export { LEAD_CAPTURE_COLUMNS } from './leadCaptureSchema';

/** Shared Google Apps Script web app for all marketing and site lead capture. */
export const LEAD_CAPTURE_SHEET_URL =
    process.env.REACT_APP_EXPOSURE_SHEET_URL
    || process.env.REACT_APP_WORKSHOP_SHEET_URL
    || 'https://script.google.com/macros/s/AKfycbxKfoH5derrc_L-_SPqjE2RJ8LHsTx-FXN8bJ_hgj7k7RbtUgB6IAmUqp9l8tva5oNhZg/exec';

export async function submitLeadCapture(fields: Record<string, string>): Promise<void>
{
    if (!LEAD_CAPTURE_SHEET_URL)
    {
        throw new Error('Lead capture sheet URL is not configured.');
    }

    const normalized = normalizeLeadCapturePayload(fields);
    const body = new URLSearchParams();

    Object.entries(normalized).forEach(([ key, value ]) =>
    {
        body.append(key, value);
    });

    await fetch(LEAD_CAPTURE_SHEET_URL, {
        method: 'POST',
        body,
        mode: 'no-cors',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
    });
}
